<script setup>
import { computed, onMounted, ref, nextTick, defineEmits } from 'vue';
import { xios } from '../forms/tempAxios';
import { Notify } from 'quasar';
import TmsTable from '../table/TmsTable.vue';

const emit = defineEmits(['update:selected']);
// User info from localStorage
const userInfo = ref(JSON.parse(localStorage.getItem('userInfo')));

// Add actions column
const columnsType = [
  {
    name: 'companyName',
    label: 'Company Name',
  },
  {
    name: 'orders',
    label: 'No of Orders',
  },
  {
    name: 'businessNature',
    label: 'Nature of Business',
  },
  {
    name: 'companyRegistration',
    label: 'Registration No',
  },
  {
    name: 'contactPerson',
    label: 'Contact Person',
  },
  {
    name: 'contactPhone',
    label: 'Phone No',
  },
];

const columns = computed(() => {
  let arr = [];
  columnsType.forEach((e) => {
    e.align = 'left';
    e.field = e.name;
    arr.push(e);
  });
  // Add actions column for edit button
  arr.push({
    name: 'actions',
    label: 'Actions',
    field: 'actions',
    align: 'left'
  });
  return arr;
});

const data = ref([]);

onMounted(async () => {
  await nextTick();
  data.value = await fetchData();
  console.log("CustomerList - Fetched data:", data.value);
});

async function fetchData() {
  try {
    const clientId = userInfo.value && userInfo.value.uid ? userInfo.value.uid : 1;
    console.log("CustomerList - Using client ID:", clientId);

    const res = await xios.post('api-tms/script-pagination-standard', {
      model: 'Customer',
      itemsPerPage: 10,
      page: 1,
      sortBy: 'companyName',
      orderBy: 'ASC',
      searchQuery: '',
      searchFields: ['companyName', 'companyRegistration', 'contactPerson'],
      attributesInclude: [],
      includeModels: [
        {
          model: 'Poi',
        },
      ],
      filterFields: [
        {
          field: 'status',
          operator: 'eq',
          value: 1,
        },
        {
          field: 'clientId',
          operator: 'eq',
          value: clientId
        },
      ],
    });
    
    if (res.data.success) {
      return res.data.data.items;
    } else {
      Notify.create({
        message: 'Failed to load customers',
        color: 'negative'
      });
      return [];
    }
  } catch (error) {
    console.error('Error fetching customers:', error);
    Notify.create({
      message: 'Error loading customer data',
      color: 'negative'
    });
    return [];
  } 
}

// Edit customer function
function editCustomer(customerData) {
  if (!customerData || !customerData.id) {
    Notify.create({
      message: 'Invalid customer data',
      color: 'negative'
    });
    return;
  }
  
  console.log(`Editing customer with ID: ${customerData.id}`);
  
  // Set customer ID in localStorage for edit mode
  localStorage.setItem('currentCustomerId', customerData.id);
  
  // Update parent selected view through emit
  emit('update:selected', 'Create Customer');
}

</script>

<template>
  <TmsTable 
    :data="data" 
    :selected="$attrs.selected" 
    :columns="columns" 
    row-key="id"
    :action="editCustomer"
  />
</template>

